import styled from 'styled-components/macro';

export const StyledImage = styled.img<{
  isLoading: boolean;
  isTransitioning: boolean;
}>`
  position: absolute;
  object-fit: contain;
  opacity: ${(props) => (props.isTransitioning ? '0.5' : '1')};
  transition: filter 0.2s linear, opacity 300ms ease-in-out;
  filter: ${(props) => (props.isLoading ? 'blur(4px)' : 'none')};
  -webkit-filter: ${(props) => (props.isLoading ? 'blur(4px)' : 'none')};
`;

export const StyledImageBackground = styled(StyledImage)`
  object-fit: cover !important;
  inset: 0;
  filter: blur(15px);
  -webkit-filter: blur(15px);
  transform: scale(1.2);
`;

export const LoaderWrapper = styled.div`
  position: absolute;
  z-index: 10;
  inset: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
